module.exports = kolibriCoreAppGlobal.lib.logging;